export const FETCH_COLLECTION_REQUEST = 'FETCH_COLLECTION_REQUEST';
export const FETCH_COLLECTION_SUCCESS = 'FETCH_COLLECTION_SUCCESS';
export const FETCH_COLLECTION_FAILURE = 'FETCH_COLLECTION_FAILURE';

export const FETCH_BRAND_REQUEST = 'FETCH_BRAND_REQUEST';
export const FETCH_BRAND_SUCCESS = 'FETCH_BRAND_SUCCESS';
export const FETCH_BRAND_FAILURE = 'FETCH_BRAND_FAILURE';

export const FETCH_MARKET_REQUEST = 'FETCH_MARKET_REQUEST';
export const FETCH_MARKET_SUCCESS = 'FETCH_MARKET_SUCCESS';
export const FETCH_MARKET_FAILURE = 'FETCH_MARKET_FAILURE';

export const FETCH_CATEGORY_REQUEST = 'FETCH_CATEGORY_REQUEST';
export const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS';
export const FETCH_CATEGORY_FAILURE = 'FETCH_CATEGORY_FAILURE';

export const FETCH_SUB_CATEGORY_REQUEST = 'FETCH_SUB_CATEGORY_REQUEST';
export const FETCH_SUB_CATEGORY_SUCCESS = 'FETCH_SUB_CATEGORY_SUCCESS';
export const FETCH_SUB_CATEGORY_FAILURE = 'FETCH_SUB_CATEGORY_FAILURE';

export const FETCH_SEASONS_REQUEST = 'FETCH_SEASONS_REQUEST';
export const FETCH_SEASONS_SUCCESS = 'FETCH_SEASONS_SUCCESS';
export const FETCH_SEASONS_FAILURE = 'FETCH_SEASONS_FAILURE';

export const FETCH_FABRIC_TYPE_REQUEST = 'FETCH_FABRIC_TYPE_REQUEST';
export const FETCH_FABRIC_TYPE_SUCCESS = 'FETCH_FABRIC_TYPE_SUCCESS';
export const FETCH_FABRIC_TYPE_FAILURE = 'FETCH_FABRIC_TYPE_FAILURE';

export const FETCH_FABRIC_REQUEST = 'FETCH_FABRIC_REQUEST';
export const FETCH_FABRIC_SUCCESS = 'FETCH_FABRIC_SUCCESS';
export const FETCH_FABRIC_FAILURE = 'FETCH_FABRIC_FAILURE';

export const FETCH_FABRIC_COMPOSITION_REQUEST = 'FETCH_FABRIC_COMPOSITION_REQUEST';
export const FETCH_FABRIC_COMPOSITION_SUCCESS = 'FETCH_FABRIC_COMPOSITION_SUCCESS';
export const FETCH_FABRIC_COMPOSITION_FAILURE = 'FETCH_FABRIC_COMPOSITION_FAILURE';

export const FETCH_COLOR_REQUEST = 'FETCH_COLOR_REQUEST';
export const FETCH_COLOR_SUCCESS = 'FETCH_COLOR_SUCCESS';
export const FETCH_COLOR_FAILURE = 'FETCH_COLOR_FAILURE';

export const FETCH_COLOR_GROUP_REQUEST = 'FETCH_COLOR_GROUP_REQUEST';
export const FETCH_COLOR_GROUP_SUCCESS = 'FETCH_COLOR_GROUP_SUCCESS';
export const FETCH_COLOR_GROUP_FAILURE = 'FETCH_COLOR_GROUP_FAILURE';

export const FETCH_FABRIC_PATTERN_REQUEST = 'FETCH_FABRIC_PATTERN_REQUEST';
export const FETCH_FABRIC_PATTERN_SUCCESS = 'FETCH_FABRIC_PATTERN_SUCCESS';
export const FETCH_FABRIC_PATTERN_FAILURE = 'FETCH_FABRIC_PATTERN_FAILURE';

export const FETCH_DESIGN_DETAILS_REQUEST = 'FETCH_DESIGN_DETAILS_REQUEST';
export const FETCH_DESIGN_DETAILS_SUCCESS = 'FETCH_DESIGN_DETAILS_SUCCESS';
export const FETCH_DESIGN_DETAILS_FAILURE = 'FETCH_DESIGN_DETAILS_FAILURE';

export const FETCH_DOC_RESPONSE_REQUEST = 'FETCH_DOC_RESPONSE_REQUEST';
export const FETCH_DOC_RESPONSE_SUCCESS = 'FETCH_DOC_RESPONSE_SUCCESS';
export const FETCH_DOC_RESPONSE_FAILURE = 'FETCH_DOC_RESPONSE_FAILURE';

export const FETCH_MATERIAL_REQUEST = 'FETCH_MATERIAL_REQUEST';
export const FETCH_MATERIAL_SUCCESS = 'FETCH_MATERIAL_SUCCESS';
export const FETCH_MATERIAL_FAILURE = 'FETCH_MATERIAL_FAILURE';

export const FETCH_PRODUCT_MATERIALS_REQUEST = 'FETCH_PRODUCT_MATERIALS_REQUEST';
export const FETCH_PRODUCT_MATERIALS_SUCCESS = 'FETCH_PRODUCT_MATERIALS_SUCCESS';
export const FETCH_PRODUCT_MATERIALS_FAILURE = 'FETCH_PRODUCT_MATERIALS_FAILURE';

export const FETCH_TRIMS_REQUEST = 'FETCH_TRIMS_REQUEST';
export const FETCH_TRIMS_SUCCESS = 'FETCH_TRIMS_SUCCESS';
export const FETCH_TRIMS_FAILURE = 'FETCH_TRIMS_FAILURE';

export const FETCH_TRIMS_TYPE_REQUEST = 'FETCH_TRIMS_TYPE_REQUEST';
export const FETCH_TRIMS_TYPE_SUCCESS = 'FETCH_TRIMS_TYPE_SUCCESS';
export const FETCH_TRIMS_TYPE_FAILURE = 'FETCH_TRIMS_TYPE_FAILURE';

export const FETCH_POM_AND_SIZE_REQUEST = 'FETCH_POM_AND_SIZE_REQUEST';
export const FETCH_POM_AND_SIZE_SUCCESS = 'FETCH_POM_AND_SIZE_SUCCESS';
export const CLEAR_POM_AND_SIZE = 'CLEAR_POM_AND_SIZE';
export const FETCH_POM_AND_SIZE_FAILURE = 'FETCH_POM_AND_SIZE_FAILURE';

export const FETCH_PRODUCT_MEASUREMENT_REQUEST = 'FETCH_PRODUCT_MEASUREMENT_REQUEST';
export const FETCH_PRODUCT_MEASUREMENT_SUCCESS = 'FETCH_PRODUCT_MEASUREMENT_SUCCESS';
export const FETCH_PRODUCT_MEASUREMENT_FAILURE = 'FETCH_PRODUCT_MEASUREMENT_FAILURE';
export const FETCH_PRODUCT_MEASUREMENT_SUCCESS_DESIGN_TECHPACK =
	'FETCH_PRODUCT_MEASUREMENT_SUCCESS_DESIGN_TECHPACK';

export const FETCH_ALL_TEMPLATE_REQUEST = 'FETCH_ALL_TEMPLATE_REQUEST';
export const FETCH_ALL_TEMPLATE_SUCCESS = 'FETCH_ALL_TEMPLATE_SUCCESS';
export const FETCH_ALL_TEMPLATE_FAILURE = 'FETCH_ALL_TEMPLATE_FAILURE';

export const FETCH_BRANDING_CATEGORY_REQUEST = 'FETCH_BRANDING_CATEGORY_REQUEST';
export const FETCH_BRANDING_CATEGORY_SUCCESS = 'FETCH_BRANDING_CATEGORY_SUCCESS';
export const FETCH_BRANDING_CATEGORY_FAILURE = 'FETCH_BRANDING_CATEGORY_FAILURE';

export const FETCH_BRANDING_TYPE_REQUEST = 'FETCH_BRANDING_TYPE_REQUEST';
export const FETCH_BRANDING_TYPE_SUCCESS = 'FETCH_BRANDING_TYPE_SUCCESS';
export const FETCH_BRANDING_TYPE_FAILURE = 'FETCH_BRANDING_TYPE_FAILURE';

export const FETCH_INITIAL_COSTING_REQUEST = 'FETCH_INITIAL_COSTING_REQUEST';
export const FETCH_INITIAL_COSTING_SUCCESS = 'FETCH_INITIAL_COSTING_SUCCESS';
export const FETCH_INITIAL_COSTING_FAILURE = 'FETCH_INITIAL_COSTING_FAILURE';

export const FETCH_QUANTITY_WISE_REQUEST = 'FETCH_QUANTITY_WISE_REQUEST';
export const FETCH_QUANTITY_WISE_SUCCESS = 'FETCH_QUANTITY_WISE_SUCCESS';
export const FETCH_QUANTITY_WISE_FAILURE = 'FETCH_QUANTITY_WISE_FAILURE';

export const FETCH_PRODUCT_STEPS_REQUEST = 'FETCH_PRODUCT_STEPS_REQUEST';
export const FETCH_PRODUCT_STEPS_SUCCESS = 'FETCH_PRODUCT_STEPS_SUCCESS';
export const FETCH_PRODUCT_STEPS_FAILURE = 'FETCH_PRODUCT_STEPS_FAILURE';

export const FETCH_ENUM_FILTER_REQUEST = 'FETCH_ENUM_FILTER_REQUEST';
export const FETCH_ENUM_FILTER_SUCCESS = 'FETCH_ENUM_FILTER_SUCCESS';
export const FETCH_ENUM_FILTER_FAILURE = 'FETCH_ENUM_FILTER_FAILURE';

export const FETCH_EMBELLISHMENT_SUB_CATEGORY_REQUEST = 'FETCH_EMBELLISHMENT_SUB_CATEGORY_REQUEST';
export const FETCH_EMBELLISHMENT_SUB_CATEGORY_SUCCESS = 'FETCH_EMBELLISHMENT_SUB_CATEGORY_SUCCESS';
export const FETCH_EMBELLISHMENT_SUB_CATEGORY_FAILURE = 'FETCH_EMBELLISHMENT_SUB_CATEGORY_FAILURE';

export const FETCH_TRIMS_SUB_CATEGORY_REQUEST = 'FETCH_TRIMS_SUB_CATEGORY_REQUEST';
export const FETCH_TRIMS_SUB_CATEGORY_SUCCESS = 'FETCH_TRIMS_SUB_CATEGORY_SUCCESS';
export const FETCH_TRIMS_SUB_CATEGORY_FAILURE = 'FETCH_TRIMS_SUB_CATEGORY_FAILURE';

export const FETCH_LABEL_PACK_SUB_TYPE_REQUEST = 'FETCH_LABEL_PACK_SUB_TYPE_REQUEST';
export const FETCH_LABEL_PACK_SUB_TYPE_SUCCESS = 'FETCH_LABEL_PACK_SUB_TYPE_SUCCESS';
export const FETCH_LABEL_PACK_SUB_TYPE_FAILURE = 'FETCH_LABEL_PACK_SUB_TYPE_FAILURE';

export const UPDATE_DESIGN_SUCCESS = 'UPDATE_DESIGN_SUCCESS';
export const UPDATE_DESIGN_FAILURE = 'UPDATE_DESIGN_FAILURE';

export const FETCH_SIZE_FOR_PRODUCT_SUCCESS = 'FETCH_SIZE_FOR_PRODUCT_SUCCESS';
export const FETCH_SIZE_FOR_PRODUCT_FAILURE = 'FETCH_SIZE_FOR_PRODUCT_FAILURE';

export const LIKE_DESIGN_SUCCESS = 'LIKE_DESIGN_SUCCESS';
export const LIKE_DESIGN_FAILURE = 'LIKE_DESIGN_FAILURE';

export const UNLIKE_DESIGN_SUCCESS = 'UNLIKE_DESIGN_SUCCESS';
export const UNLIKE_DESIGN_FAILURE = 'UNLIKE_DESIGN_FAILURE';

export const REMOVE_DESIGN_AFTER_MOVE = 'REMOVE_DESIGN_AFTER_MOVE';

export const STORE_COLLECTION_PRODUCTS = 'STORE_COLLECTION_PRODUCTS';
